<template>
  <div>
    <div v-if="isAdmin" style="position:absolute;top:5px;right:5px;">
      <div  v-on:click="handleDownload" style="margin:3px;cursor:pointer;padding:5px 12px;color:#fff;text-decoration:none;background-color:#ce0e2d;border-radius:6px;display:inline-block">Download Template</div>
      <div v-on:click="handleEmail" style="margin:3px;cursor:pointer;padding:5px 12px;color:#fff;text-decoration:none;background-color:#ce0e2d;border-radius:6px;display:inline-block">Send Test Email</div>
      <input type="text" placeholder="to" v-model="toAddress" />
    </div>
    <div ref="newsletter">
      <div style="background-color:#f9f9f9;font-family: gibbs, sans-serif;font-size:16px">
        <router-view />
      </div>
    </div>
    <div>
      <p style="text-align:center;color:#7a7157;padding:25px 0 50px 0">Don't want to receive this enewsletter? You can unsubscribe <span style="text-decoration:underline">here</span>.</p>
      <a :href="theData" ref="downloadLink" download="newsletter.html" style="display:none">Data is here now</a>
    </div>
  </div>
</template>

<script>
export default {

  data () {
    return {
      theData: null,
      testing: true,
      toAddress: ''
    }
  },
  computed: {
    isAdmin () {
      return this.$store.state.signedInAdmin
    },
    ntroute () {
      return this.$route.path !== '/email-signatures'
    }
  },
  created () {
    this.checkin()
  },
  methods: {
    handleDownload () {
      let html = this.$refs.newsletter.innerHTML;
      this.theData = 'data:text/html;charset=UTF-8,' + encodeURIComponent(html);
      this.$nextTick(() => {
        this.$refs.downloadLink.click()
      })
    },
    async handleEmail() {
      
      let html = this.$refs.newsletter.innerHTML;
      let data = { subject: this.$route.path + ' email test', html: html, toAddress: this.toAddress }
      let res = await this.$apix.post('events/newsletter-test', data, { headers: {'Authorization': this.$store.state.adminToken } })
      console.log('res.data', res.data)
      alert('Email sent: ' + JSON.stringify(res.data))
    },
    async checkin() {
      await this.$store.dispatch('checkUser')
    }
  }
}
</script>

<style>

</style>